import { Navigate } from 'react-router-dom'

const RedirectHome = () => {
  const isAuthenticated = !!localStorage.getItem('access_token')
  return <Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />
}

export default RedirectHome
